<template>
    <section id="contact">
        <div class="row no-gutters">
            <div class="col-lg-6 col-md12 frame reddet">
                <div class="container">
                    <div class="row text-center align-items-center bordered-container">
                        <div class="col">
                            <h2>¿NECESITAS <br> AYUDA?</h2>
                            <!-- <a class="text-white" target="_blank" href="https://grupocosmic.zendesk.com">
                                <h2>¿NECESITAS <br> AYUDA?</h2>
                            </a> -->
                            <form action="https://grupocosmic.zendesk.com" target="_blank">
                                <button class="button1" role="button">
                                    Crear Solicitud
                                </button>
                            </form>
                            <hr class="light" data-aos="fade-right">
                            <h2>MESA DE CONTROL</h2>
                            <br>
                            <i class="fas fa-mobile-alt extra-big"></i>
                            <p class="big">
                                800 2889 353 <br>
                                <i class="fab fa-whatsapp"></i> 55 6675 0481
                            </p>
                            <br>
                            <i class="fas fa-envelope-square extra-big"></i>
                            <p class="big">
                                <a class="text-white"
                                    href="mailto:mesadecontrol@cosmic.com.mx">mesadecontrol@cosmic.com.mx</a>
                            </p>
                            <hr class="light" data-aos="fade-right">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md12">
                <div id="work">
                    <div class="row h-100 front">
                        <div class="col-sm-12 my-auto">
                            <h3 class="text-center">¿QUIERES TRABAJAR CON NOSOTROS?</h3>
                            <p class="text-center">
                                Consulta nuestra bolsa de trabajo <br>
                                800-28-89-353 <br>
                                o <br>
                                <!-- <a target="_blank" href="https://career19.sapsf.com/career?company=grupoconso&career%5fns=job%5flisting%5fsummary&navBarLevel=JOB%5fSEARCH&_s.crb=vFCgU36g%2bHyOPLip6iLygqr3vWnHUqZBubi0D40EPiw%3d">
                                  http://empleo.cosmic.mx
                                </a> -->
                                <br />
                                <a target="_blank" href="https://cosmic.pandape.computrabajo.com/">
                                    https://cosmic.pandape.computrabajo.com/
                                </a>
                                <br />
                                <a target="_blank" href="https://mx.indeed.com/cmp/Grupo-Cosmic/jobs">
                                    Trabajo y empleo en Grupo Cosmic | Indeed.com
                                </a>
                                <br />
                                <br />
                                <a target="_blank" href="/../files/AVISO DE PRIVACIDAD GC AUTORIZADO 2021.pdf">
                                    Aviso de Privacidad
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <a target="_blank" href="http://siga-pin.com/">
                    <div id="cfdi">
                        <div class="row h-100 front" slot="front">
                            <div class="col-sm-12 my-auto">
                                <h2 class="text-center">Recibos CFDI</h2>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Work',
    components: {
    },
    data() {
        return {

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big {
    font-size: 1em;
}

@media (min-width: 992px) {
    .big {
        font-size: 2em;
    }
}

.extra-big {
    font-size: 4.5em;
}

.frame {
    padding: 15px;
    max-height: 800px;
}

.bordered-container {
    border: 1px solid #fff;
    padding: 15px;
    height: 770px;
    color: #fff;
}

.bordered-container h1,
.bordered-container h2 {
    color: #fff;
}


.button1 {
    align-items: center;
    appearance: none;
    background-image: radial-gradient(100% 100% at 100% 0, #c96b69 0, #c82b29 100%);
    border: 0;
    border-radius: 6px;
    box-shadow: rgba(66, 35, 38, 0.4) 0 2px 4px, rgba(66, 35, 38, 0.4) 0 7px 13px -3px, rgba(66, 35, 38, 0.4) 0 -3px 0 inset;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    font-family: "JetBrains Mono", monospace;
    height: 48px;
    justify-content: center;
    line-height: 1;
    list-style: none;
    overflow: hidden;
    padding-left: 16px;
    padding-right: 16px;
    position: relative;
    text-align: left;
    text-decoration: none;
    transition: box-shadow .15s, transform .15s;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    white-space: nowrap;
    will-change: box-shadow, transform;
    font-size: 18px;
}

.button1:focus {
    box-shadow: rgba(66, 35, 38, 0.4) 0 2px 4px, rgba(66, 35, 38, 0.4) 0 7px 13px -3px, rgba(66, 35, 38, 0.4) 0 -3px 0 inset;
}

.button1:hover {
    box-shadow: rgba(66, 35, 38, 0.4) 0 4px 8px, rgba(66, 35, 38, 0.4) 0 7px 13px -3px, #7c0c0a 0 -3px 0 inset;
    transform: translateY(-2px);
}

.button1:active {
    box-shadow: #c82b29 0 3px 7px inset;
    transform: translateY(2px);
}
</style>



// WEBPACK FOOTER //
// src/components/work/Work.vue